import { render, staticRenderFns } from "./StudentPage.vue?vue&type=template&id=6e01f9d4&"
import script from "./StudentPage.vue?vue&type=script&lang=ts&"
export * from "./StudentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e01f9d4')) {
      api.createRecord('6e01f9d4', component.options)
    } else {
      api.reload('6e01f9d4', component.options)
    }
    module.hot.accept("./StudentPage.vue?vue&type=template&id=6e01f9d4&", function () {
      api.rerender('6e01f9d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/340th/Student/StudentPage.vue"
export default component.exports